import React, { PureComponent } from 'react';

import Icon from  './icon';

const WIDTH = 9/12;
const HEIGHT = 7/12;

const Element = ({ className, getSize, color, style }) => (
    <svg className={className} style={style} width={getSize(WIDTH)} height={getSize(HEIGHT)} viewBox="0 0 9 7" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <path d="M2.822 6.178a.857.857 0 0 0 1.213 0l4.714-4.715A.857.857 0 1 0 7.537.251l-4.108 4.12-1.966-1.977A.857.857 0 0 0 .251 3.606l2.571 2.572z" fill={color} fillRule="evenodd"/>
    </svg>
)

export default class IconTask extends PureComponent {
    render() {
        return <Icon color={this.props.color} size={this.props.size} style={this.props.style} baseline={this.props.baseline} className={this.props.className}><Element /></Icon>;
    }
}
